<!-- @format -->

<ng-container *transloco="let t">
  @if (stateObject) {
    @if (stateObject.type === "ModuleStateObject" && stateObject.isAttained) {
      <ng-container [ngTemplateOutlet]="attainedModuleTpl" />
    } @else if (stateObject.type === "ModuleStateObject") {
      <ng-container [ngTemplateOutlet]="stateTpl" [ngTemplateOutletContext]="{ state: stateObject.planState }" />
    } @else if (stateObject.type === "EducationStateObject") {
      <ng-container [ngTemplateOutlet]="stateTpl" [ngTemplateOutletContext]="{ state: stateObject.educationValidationResult.state }" />
    } @else if (stateObject.type === "CustomModuleAttainmentStateObject") {
      <ng-container [ngTemplateOutlet]="attainedModuleTpl" />
    }
  }

  <ng-template #attainedModuleTpl>
    <div class="sis-plan-structure-module-selection-state">
      <div class="sis-plan-structure-module-selection-state__status">
        <p class="sis-plan-structure-module-selection-state__status--attained sis-mb-zero">
          <fudis-icon [icon]="'achievement'" [color]="'green'" />
          {{ t("SIS_COMPONENTS.PLAN_STATE.ATTAINED") }}
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template #stateTpl let-state="state">
    <div class="sis-plan-structure-module-selection-state">
      <div class="sis-plan-structure-module-selection-state__status">
        <p
          class="sis-mb-zero"
          [ngClass]="{
            'sis-plan-structure-module-selection-state__status--attained': state === 'ATTAINED' || state === 'PARTS_ATTAINED',
            'sis-plan-structure-module-selection-state__status--invalid':
              state === 'INVALID' ||
              state === 'APPROVAL_REQUIRED' ||
              state === 'MODULECONTENTAPPROVAL_VALIDATION_STATE_INVALID_REQUESTED' ||
              state === 'MODULECONTENTAPPROVAL_VALIDATION_STATE_INVALID_ACCEPTED' ||
              state === 'REJECTED',
          }">
          @switch (state) {
            @case ("ATTAINED") {
              <fudis-icon [icon]="'achievement'" [color]="'green'" />
            }
            @case ("PARTS_ATTAINED") {
              <fudis-icon [icon]="'achievement'" [color]="'green'" />
            }
            @case ("INVALID") {
              <fudis-icon [icon]="'alert'" [color]="'red'" />
            }
            @case ("INCOMPLETE") {
              <fudis-icon [icon]="'exclamation-mark-circle'" />
            }
            @case ("PLANNED") {
              <fudis-icon [icon]="'check'" [color]="'green'" />
            }
            @case ("APPROVED") {
              <fudis-icon [icon]="'check'" [color]="'green'" />
            }
            @case ("APPROVED_CONDITIONALLY") {
              <fudis-icon [icon]="'check'" [color]="'green'" />
            }
            @case ("APPROVED_CONDITIONALLY_PARTS_ATTAINED") {
              <fudis-icon [icon]="'achievement'" [color]="'green'" />
            }
            @case ("APPROVED_PARTS_ATTAINED") {
              <fudis-icon [icon]="'achievement'" [color]="'green'" />
            }
            @case ("APPROVAL_REQUIRED") {
              <fudis-icon [icon]="'alert'" [color]="'red'" />
            }
            @case ("MODULECONTENTAPPROVAL_VALIDATION_STATE_INVALID_REQUESTED") {
              <fudis-icon [icon]="'alert'" [color]="'red'" />
            }
            @case ("MODULECONTENTAPPROVAL_VALIDATION_STATE_INVALID_ACCEPTED") {
              <fudis-icon [icon]="'alert'" [color]="'red'" />
            }
            @case ("REJECTED") {
              <fudis-icon [icon]="'alert'" [color]="'red'" />
            }
            @default {
              <fudis-icon [icon]="'info-circle'" [color]="'primary'" />
            }
          }
          {{ t("SIS_COMPONENTS.PLAN_STATE." + state) }}
        </p>
      </div>
    </div>
  </ng-template>
</ng-container>
